import commonService from "../../common";
import dateService from "../../bookBookingDate";
const clonedeep = require("lodash/cloneDeep");

export const getDataDivisions = (
  storeDivisions,
  masterBook,
  selectedDate,
  previousDivisions = null
) => {
  if (masterBook.length == 0) return [];

  var returnDivisions = [];
  // storeの storeDivisions がnullであれば初期化
  if (storeDivisions === null) {
    // dataDivisionsを編集して適切な値を投入
    returnDivisions = dataDivisionArrangement(
      masterBook,
      selectedDate,
      previousDivisions
    );
  } else {
    // 購入確認画面からもどってきた等はstoreに保持した値をdataに代入
    // vuexのエラーが出るので、storeの値をdeep copy
    returnDivisions = clonedeep(storeDivisions);
  }
  return returnDivisions;
};

// dataのDivisionsを商材に適した値を投入する関数
const dataDivisionArrangement = (
  masterBook,
  selectedDate,
  previousDivisions = null
) => {
  var uniqueDivisions = makeUniqueDivisionsArray(masterBook, selectedDate);

  var hasSetInitCount = false;
  let returnDataDivisions = [];
  commonService
    .sortByDisplayOrder(uniqueDivisions)
    .forEach((division, index) => {
      const dataDivisionElement = makeDataDivision(
        masterBook,
        division,
        hasSetInitCount
      );

      // おとなA→おとなBのように区分名が変わっても枚数を維持するため、previousDivisionsとindexで対応
      if (previousDivisions && previousDivisions[index]) {
        const previousDivision = previousDivisions[index];
        if (previousDivision.count > 0) {
          dataDivisionElement.count = Math.min(
            previousDivision.count,
            dataDivisionElement.maxPurchaseCount
          );
          hasSetInitCount = true;
        }
      }

      // 購入可能な先頭のdivisionの初期値を1にする（以前のcountが引き継がれていない場合のみ）
      if (!hasSetInitCount && dataDivisionElement.maxPurchaseCount > 0) {
        dataDivisionElement.count = 1;
        hasSetInitCount = true;
      }
      // data内のdivisionsへの登録
      returnDataDivisions.push(dataDivisionElement);
    });
  return returnDataDivisions;
};

// masterBook.master_pricesをループ処理して、ユニークなDivisionの配列を作る
// Division: ex) { dataName: "adult", name: "おとな" }
const makeUniqueDivisionsArray = (masterBook, selectedDate) => {
  // サブスクの場合はdivisionがnullなので、おとなで返す
  if (commonService.checkIsSubscription(masterBook.id)) {
    return [{ dataName: "adult", name: "おとな" }];
  } else {
    try {
      var divisions = [];
      // 料金カレンダー場合は日付ごとに価格設定が異なるので、price_calendarsから料金を取得する。
      let masterPrices = dateService.checkIsPriceCalendar(masterBook)
        ? masterBook.price_calendars.find((e) => e.start_date === selectedDate)
            .master_prices
        : masterBook.master_prices;

      masterPrices =
        commonService.sortByDisplayOrder(masterPrices) || masterPrices;
      masterPrices.forEach((price) => {
        if (!divisions.some((e) => e.dataName === price.division)) {
          divisions.push({
            dataName: price.division,
            name: price.division_name,
          });
        }
      });
      return divisions;
    } catch {
      return [];
    }
  }
};

// data内のdivisionsを作成
const makeDataDivision = (masterBook, division) => {
  let returnDataDivision = {
    dataName: division.dataName,
    name: division.name,
    count: 0,
    maxPurchaseCount: 10,
  };

  const limitedType = masterBook._max_purchase_count[0].limited_type;

  // division毎に上限数が設定されている場合
  if (limitedType == "division") {
    const targetGettableCountData =
      masterBook._max_purchase_count[0].gettable_counts.find(
        (e) => e.division === division.dataName
      );

    // is_limited: false の場合はcountが存在しないので、デフォルト:10
    returnDataDivision.maxPurchaseCount = targetGettableCountData.is_limited
      ? targetGettableCountData.count
      : 10;

    // チケット全体で上限数が設定されている場合
    // これだけだと上限枚数制御は不十分だが、ここではdivision毎の上限だけ設定して、合計の制御はコンポーネント側に任せる
  } else if (limitedType == "master_book") {
    // gettable_counts[0]のみ存在するので、その値を使用する
    returnDataDivision.maxPurchaseCount =
      masterBook._max_purchase_count[0].gettable_counts[0].count;
  }
  return returnDataDivision;
};
